import React, { useEffect, useState } from 'react';
import { compareAsc, parseJSON } from 'date-fns';

import {
    Box, Grid2, IconButton, Typography, FormControl, InputLabel,
    Select, MenuItem
} from '@mui/material';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { HOURS, PERIOD } from '../../constants/constants';

const AvailabilityDay = ({
    index, day: { enabled, start_date, end_date, start_period, end_period },
    day_of_week, text, setFormValues
}) => {
    const [timeArray, setTimeArray] = useState({
        hours: HOURS,
        periods: PERIOD
    });
    const { hours, periods } = timeArray;

    useEffect(() => {
        if (start_date && start_period) {
            if (start_period === 'am')
                setTimeArray(e => ({
                    ...e, periods: PERIOD
                }));
            else {
                setTimeArray(e => ({
                    ...e, periods: ['pm']
                }));
                setFormValues(
                    e => e.map(
                        (u, j) => j === index ?
                            {
                                ...u, schedules: {
                                    ...u.schedules, [day_of_week]: {
                                        ...u.schedules[day_of_week], end_period: 'pm'
                                    }
                                }
                            }
                            : u)
                );
            }
        }
    }, [start_date, start_period]);

    useEffect(() => {
        if (start_date && start_period && end_date && end_period) {
            const first_array = start_date.split(":").map(
                (e, i) => i === 0 ? start_period === 'pm' ? String(Number(e) + 12) : e : e
            );
            const first_date = parseJSON(`1970-01-01 ${first_array.join(":")}:00 UTC`);
            const second_array = end_date.split(":").map(
                (e, i) => i === 0 ? end_period === 'pm' ? String(Number(e) + 12) : e : e
            );
            const second_date = parseJSON(`1970-01-01 ${second_array.join(":")}:00 UTC`);
            if (compareAsc(first_date, second_date) > -1) {
                setFormValues(
                    e => e.map(
                        (u, j) => j === index ?
                            {
                                ...u, schedules: {
                                    ...u.schedules, [day_of_week]: {
                                        ...u.schedules[day_of_week], end_date: ''
                                    }
                                }
                            }
                            : u)
                );
            }

        }
    }, [start_date, start_period, end_date, end_period]);

    const onChangeDate = ({ target: { name, value } }) => {
        setFormValues(
            e => e.map(
                (u, j) => j === index ?
                    {
                        ...u, schedules: {
                            ...u.schedules, [day_of_week]: {
                                ...u.schedules[day_of_week], [name]: value
                            }
                        }
                    }
                    : u)
        );
    };

    return (
        <Grid2 size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Box className='hor_cont'>
                <Box className='day_content' sx={{ my: 'auto', width: '50px' }}>
                    <Typography variant='body1' sx={{ my: 'auto', fontWeight: '600' }}>
                        {text}
                    </Typography>
                    {
                        enabled &&
                        <Box className='disabled_top' sx={{ my: 'auto' }}>
                            <IconButton onClick={
                                () => onChangeDate({
                                    target: { name: 'enabled', value: false }
                                })
                            }>
                                <DoNotDisturbIcon />
                            </IconButton>
                        </Box>
                    }
                    {
                        !enabled &&
                        <Box className='enabled_top' sx={{ my: 'auto' }}>
                            <IconButton
                                onClick={
                                    () => onChangeDate({
                                        target: { name: 'enabled', value: true }
                                    })
                                }
                            >
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Box>
                    }
                </Box>
                <Box className='inputs_flex'>
                    <Box sx={{ my: 'auto' }}>

                        <FormControl className='hour_input' variant="outlined" sx={{ minWidth: 120, mr: 2 }}>
                            <InputLabel>Hora</InputLabel>
                            <Select
                                label="Hora"
                                name='start_date'
                                value={start_date || ""}
                                onChange={onChangeDate}
                                disabled={!enabled}
                            >
                                {
                                    hours.map(e =>
                                        <MenuItem key={e} value={e}>
                                            {e}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                        <FormControl className='hour_input' variant="outlined" sx={{ minWidth: 120 }}>
                            <InputLabel>am/pm</InputLabel>
                            <Select
                                label="am/pm"
                                name='start_period'
                                value={start_period || ""}
                                onChange={onChangeDate}
                                disabled={!enabled}
                            >
                                <MenuItem value="am">am</MenuItem>
                                <MenuItem value="pm">pm</MenuItem>
                            </Select>
                        </FormControl>
                        <Typography className='text_helper' variant='body2' color='text.secondary' sx={{ mt: .4 }}>
                            Hora de entrada
                        </Typography>
                        {/* <TimeField
                        name='monday_start_date'
                        format="hh:mm a"
                        value={start_date || ""}
                        onChange={ e => onChangeDate('start_date', e) }
                        disabled={!enabled}
                    /> */}
                    </Box>
                    <Box className='inputs_separator' sx={{ my: 'auto' }}>
                        <Typography variant='body1' sx={{ fontSize: '22px' }}>-</Typography>
                    </Box>
                    <Box className='out_hours' sx={{ my: 'auto' }}>

                        <FormControl className='hour_input' variant="outlined" sx={{ minWidth: 120, mr: 2 }}>
                            <InputLabel>Hora</InputLabel>
                            <Select
                                label="Hora"
                                name='end_date'
                                value={end_date || ""}
                                onChange={onChangeDate}
                                disabled={!enabled}
                            >
                                {
                                    hours.map(e =>
                                        <MenuItem key={e} value={e}>
                                            {e}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                        <FormControl className='hour_input' variant="outlined" sx={{ minWidth: 120 }}>
                            <InputLabel>am/pm</InputLabel>
                            <Select
                                label="am/pm"
                                name='end_period'
                                value={end_period || ""}
                                onChange={onChangeDate}
                                disabled={!enabled}
                            >
                                {
                                    periods.map(e =>
                                        <MenuItem key={e} value={e}>
                                            {e}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                        <Typography className='text_helper' variant='body2' color='text.secondary' sx={{ mt: .4 }}>
                            Hora de salida
                        </Typography>
                        {/* <TimeField
                        name='end_date'
                        format="hh:mm a"
                        value={end_date || ""}
                        onChange={ e => onChangeDate('end_date', e) }
                        disabled={!enabled}
                    /> */}
                    </Box>
                </Box>
                {
                    enabled &&
                    <Box className='disabled_bottom' sx={{ my: 'auto' }}>
                        <IconButton onClick={
                            () => onChangeDate({
                                target: { name: 'enabled', value: false }
                            })
                        }>
                            <DoNotDisturbIcon />
                        </IconButton>
                    </Box>
                }
                {
                    !enabled &&
                    <Box className='enabled_bottom' sx={{ my: 'auto' }}>
                        <IconButton
                            onClick={
                                () => onChangeDate({
                                    target: { name: 'enabled', value: true }
                                })
                            }
                        >
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Box>
                }
                {/* <Box sx={{ my: 'auto' }}>
                    <IconButton>
                        <ContentCopyIcon />
                    </IconButton>
                </Box> */}
            </Box>
        </Grid2>
    );
};

export default AvailabilityDay;